import { render, staticRenderFns } from "./MoreForm.vue?vue&type=template&id=0766b234&scoped=true&"
import script from "./MoreForm.vue?vue&type=script&lang=js&"
export * from "./MoreForm.vue?vue&type=script&lang=js&"
import style0 from "./MoreForm.vue?vue&type=style&index=0&id=0766b234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0766b234",
  null
  
)

export default component.exports